import React from "react";
import "./Project.css";
import { FaReact, FaHardHat, FaRe } from "react-icons/fa";
import {
    SiChakraui,
    SiHtml5,
    SiExpress,
    SiMongodb,
    SiRedux,
    SiCss3,
    SiNpm
} from "react-icons/si";
import { IoLogoJavascript } from "react-icons/io";
import bellavita from "./bellavita.jpg";
import Digital from "./Digital.jpg"
import ayoya from "./ayoya.jpg"
import sephora from "./sephora.jpg";
import asos from "./Asos.jpg"
export const Project = () => {
    return (
        <>
            <div className="section">
                <h2 className="section__title different">Projects</h2>
                <div className="allProjects">


                    {/* 1 project */}
                    <div className="projects_container" data-aos="fade-right">
                        <div className="project">
                            <div className="project_videocontainer">
                                <div>
                                    <img
                                        src={ayoya}
                                        alt="ayoa.com"
                                        style={{ height: "200px" }}

                                    />
                                </div>
                            </div>
                            <div className="project_information">
                                <h2>Ayoa.com Clone<br /> (Collaborative)</h2>
                                <p>
                                    Ayoa seamlessly syncs all your work across the devices that you're using.
                                </p>
                                <div>
                                    <FaReact />
                                    <SiRedux />
                                    <IoLogoJavascript />
                                    <SiExpress />
                                    <SiMongodb />
                                    <SiHtml5 />
                                    <SiCss3 />
                                </div>
                                <div>
                                    <a
                                        href="https://funny-buttercream-0aca42.netlify.app/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span type="button" className="btns onbt">
                                            See this Live
                                        </span>
                                    </a>
                                    <a
                                        href="https://github.com/Srahul2244/grouchy-dinner-9447"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span type="button" className="btns onbt">
                                            View Code
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 2 project */}
                    <div className="projects_container" data-aos="fade-right">
                        <div className="project">
                            <div className="project_videocontainer">
                                <div>
                                    <img
                                        src={Digital}
                                        alt="Digital"
                                    />
                                </div>
                            </div>
                            <div className="project_information">
                                <h2>The Digital Garage<br /> (Individual)</h2>
                                <p>
                                    Google Digital Garage Online Courses Discover a range of free learning content designed to help grow your business.
                                </p>
                                <div>
                                    <SiHtml5 />
                                    <SiCss3 />
                                    <FaReact />
                                    <IoLogoJavascript />
                                    <SiExpress />
                                    <SiMongodb />

                                </div>
                                <div>
                                    <a
                                        href="https://calm-puppy-6598f8.netlify.app/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >

                                        <span type="button" className="btns onbt">
                                            See this Live
                                        </span>
                                    </a>
                                    <a
                                        href="https://github.com/Srahul2244/recondite-ball-5601"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span type="button" className="btns onbt">
                                            View Code
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>



                    {/* 3 project */}
                    <div className="projects_container" data-aos="fade-right">
                        <div className="project">
                            <div className="project_videocontainer">
                                <div>
                                    <img
                                        src={asos}
                                        style={{ height: "200px" }}
                                        alt="Asos.com"
                                    />
                                </div>
                            </div>
                            <div className="project_information">
                                <h2> Asos App Clone <br /> (Collaborative)</h2>
                                <p>
                                    ASOS plc is a British online fashion and cosmetic retailer. The company was founded in 2000 in London, primarily aimed at young adults.
                                </p>
                                <div>
                                    <SiHtml5 />
                                    <SiCss3 />
                                    <FaReact />
                                    <IoLogoJavascript />
                                    <SiExpress />
                                    <SiMongodb />

                                </div>
                                <div>
                                    <a
                                        href="https://asos-team-robin.netlify.app/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span type="button" className="btns onbt onbt">
                                            See this Live
                                        </span>
                                    </a>
                                    <a
                                        href="https://github.com/Srahul2244/Asos/tree/master"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span type="button" className="btns onbt">
                                            View Code
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* 4 project */}
                    <div className="projects_container" data-aos="fade-right">
                        <div className="project">
                            <div className="project_videocontainer">
                                <div>
                                    <img
                                        src={sephora}
                                        style={{ height: "200px" }}
                                        alt="Sephora.com"
                                    />
                                </div>
                            </div>
                            <div className="project_information">
                                <h2> Sephora App Clone<br />(Collaborative)</h2>
                                <p>
                                    Sephora is a French multinational retailer of personal care and beauty products.
                                </p>
                                <div>
                                    <SiHtml5 />
                                    <SiCss3 />
                                    <FaReact />
                                    <IoLogoJavascript />
                                    <SiExpress />
                                    <SiMongodb />

                                </div>
                                <div>
                                    <a
                                        href="https://sephoraclone17.netlify.app/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span type="button" className="btns onbt onbt">
                                            See this Live
                                        </span>
                                    </a>
                                    <a
                                        href="https://github.com/Mshradha/sephora_clone"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <span type="button" className="btns onbt">
                                            View Code
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
};